import axiosInstance from "../utilities/axiosSetup";

export const get_user_active_call = async () => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/get-user-active-call",
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
          "X-Zoom-User-Id": sessionStorage.getItem("z_user_id"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error.response?.data || error.message);
    // Return a default response structure to prevent undefined errors
    return { message: "ERROR", data: null };
  }
};
